module.exports = __webpack_public_path__ + "img/SEL24105G.f2d10c60.jpg";